// CURSOR
const cur = document.getElementById('cur');
const cur2 = document.getElementById('cur2');
if (cur && cur2) {
  let mx=0,my=0,r2x=0,r2y=0;
  document.addEventListener('mousemove',e=>{
    mx=e.clientX;my=e.clientY;
    cur.style.left=mx+'px';cur.style.top=my+'px';
  });
  (function tick(){
    r2x+=(mx-r2x)*.1;r2y+=(my-r2y)*.1;
    cur2.style.left=r2x+'px';cur2.style.top=r2y+'px';
    requestAnimationFrame(tick);
  })();
  document.querySelectorAll('a,button,.wcard,.pkg,.svc-row').forEach(el=>{
    el.addEventListener('mouseenter',()=>{cur2.style.width='46px';cur2.style.height='46px';cur2.style.borderColor='rgba(201,168,76,.8)';});
    el.addEventListener('mouseleave',()=>{cur2.style.width='30px';cur2.style.height='30px';cur2.style.borderColor='rgba(201,168,76,.5)';});
  });
}

// SCROLL NAV
const nav=document.getElementById('nav');
if(nav){window.addEventListener('scroll',()=>{nav.classList.toggle('solid',scrollY>50);},{passive:true});}

// MOBILE MENU
const hamburger=document.querySelector('.nav-hamburger');
const mobileMenu=document.getElementById('mobile-menu');
if(hamburger&&mobileMenu){
  const setMenu=(open)=>{
    hamburger.setAttribute('aria-expanded',String(open));
    hamburger.setAttribute('aria-label',open?'Close menu':'Open menu');
    mobileMenu.setAttribute('aria-hidden',String(!open));
    document.body.classList.toggle('menu-open',open);
  };
  hamburger.addEventListener('click',()=>setMenu(hamburger.getAttribute('aria-expanded')!=='true'));
  mobileMenu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMenu(false)));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&hamburger.getAttribute('aria-expanded')==='true')setMenu(false);});
}

// SCROLL REVEAL
const io=new IntersectionObserver(entries=>{
  entries.forEach((entry,i)=>{
    if(entry.isIntersecting){setTimeout(()=>entry.target.classList.add('in'),i*70);io.unobserve(entry.target);}
  });
},{threshold:.1});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
